import React from "react";

export default function ToolCard({
  title,
  subtitle = "",
  children,
  style = {},
  bodyStyle = {},
}) {
  return (
    <div
      className="tt-tool-card"
      style={{
        border: "1px solid rgba(255,255,255,0.10)",
        borderRadius: 18,
        background: "rgba(255,255,255,0.03)",
        padding: 14,
        boxShadow: "inset 0 1px 0 rgba(255,255,255,0.03)",
        ...style,
      }}
    >
      {(title || subtitle) && (
        <div style={{ marginBottom: 12 }}>
          {title && (
            <div
              style={{
                fontSize: 14,
                fontWeight: 700,
                letterSpacing: "0.02em",
                color: "rgba(255,255,255,0.95)",
              }}
            >
              {title}
            </div>
          )}

          {subtitle && (
            <div
              style={{
                marginTop: 4,
                fontSize: 12,
                lineHeight: 1.45,
                color: "rgba(255,255,255,0.62)",
              }}
            >
              {subtitle}
            </div>
          )}
        </div>
      )}

      <div style={{ display: "grid", gap: 10, ...bodyStyle }}>{children}</div>
    </div>
  );
}